// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + ".chunk." + {"3":"e83334fa","125":"13e0aaac","247":"094cdbd0","563":"6ec89737","958":"1b382673","962":"0b48918c","974":"3eab274b"}[chunkId] + ".js";
};